import ChatInterface, { ChatInterfaceRef } from '@/components/ChatInterface'
import { useRef } from 'react'

function AsistenteIA() {
  const chatRef = useRef<ChatInterfaceRef>(null)

  return (
    <div className="relative min-h-screen bg-background flex flex-col">
      <div className="watermark" aria-hidden="true"></div>

      <div className="bg-white border-b border-gray-200 pt-16 md:pt-20">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-primary">Asistente IA — Dr. Horcon</h1>
            <p className="text-xs text-text-secondary">Consultas generales. No reemplaza la atención presencial.</p>
          </div>
          <button
            type="button"
            onClick={() => chatRef.current?.clearChat()}
            className="px-3 py-1.5 rounded-lg bg-primary/10 hover:bg-primary/20 text-primary text-xs font-medium"
          >
            Limpiar chat
          </button>
        </div>
      </div>

      <section className="flex-1 min-h-0 bg-background flex flex-col">
        <div className="max-w-3xl mx-auto w-full flex-1 min-h-0 flex flex-col">
          <ChatInterface ref={chatRef} showHeader={false} />
        </div>
      </section>
    </div>
  )
}

export default AsistenteIA